import { LoadingOutlined } from "@ant-design/icons";
import { Radio, RadioChangeEvent } from "antd";
import { useSelector } from "react-redux";

import { stateGlobal } from "../../../../interfaces/Global";

import './style.css';

interface IOption {
    value: any;
    label: string;
}

interface IProps {
    initialValue?: any;
    onChange?: (e: RadioChangeEvent) => void;
    disabled?: boolean;
    isSubmiting?: boolean;
    options: IOption[];
    value?: any;
}

export default function RadioInput({
    initialValue,
    onChange,
    disabled,
    isSubmiting,
    options,
    value,
}: IProps) {
    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <Radio.Group
            value={value !== undefined ? value : initialValue}
            className="radio-saldo-de-contas"
            onChange={onChange}
            disabled={disabled || isSubmiting}
            style={{
                border: `1px solid ${propsState.theme === 'light' ? '#0000000f' : '#ffffff1f'}`,
                padding: 2,
                borderRadius: 6,
            }}
            buttonStyle={"solid"}
        >
            {
                options.map((option) => {
                    const selected = option.value === value;

                    return (
                        <Radio.Button
                            key={option.value}
                            value={option.value}
                            style={{
                                color: selected ? '#FFFFFF' : undefined,
                                background: selected ? '#1890ff' : undefined,
                                borderRadius: 4,
                                border: 'none'
                            }}
                        >
                            {option.label}{isSubmiting && selected && <LoadingOutlined style={{ marginLeft: 8 }} />}
                        </Radio.Button>
                    )
                })
            }
        </Radio.Group>
    )
}
